<template>
  <div class="match-bets-container">
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(0, 6)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-locked-1:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(0, 6)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-locked-1:2'"
          v-else
        />
      </transition>
    </div>
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(6, 12)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[6+index].initialSpecial"
        />
      </div>
    </div>
    <div class="row row-light match-bets">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-locked-2:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(6, 12)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-locked-2:2'"
          v-else
        />
      </transition>
    </div>
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(12, 18)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[12+index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-locked-3:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(12, 18)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-locked-3:2'"
          v-else
        />
      </transition>
    </div>
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(18, 24)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[18+index].initialSpecial"
        />
      </div>
    </div>
    <div class="row row-light">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-locked-4:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(18, 24)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-locked-4:2'"
          v-else
        />
      </transition>
    </div>
  </div>
</template>

<script>
import SportHeaderBet from '@/components/common/sport-header-bet/SportHeaderBet.vue';
import MatchBet from '@/components/common/match-bet/MatchBet.vue';
import MatchLocked from '@/components/common/match-locked/MatchLocked.vue';

export default {
  name: 'MatchBets',
  components: {
    SportHeaderBet,
    MatchBet,
    MatchLocked,
  },
  props: {
    idSport: {
      required: true,
      type: Number,
    },
    idMatch: {
      required: true,
      type: Number,
    },
    matchBettingStatus: {
      required: true,
      type: Boolean,
    },
    matchStatusPeriod: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      betsCount: 24,
    };
  },
  computed: {
    matchBets() {
      const matchBets = this.$store.getters.getActiveMatchBets(this.idMatch, this.betsCount);

      const diff = this.betsCount - matchBets.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i += 1) {
          matchBets.push({});
        }
      }

      return matchBets;
    },
    matchBetsHeaders() {
      const headerBets = [];

      for (let i = 0; i < this.betsCount; i += 1) {
        const matchBet = this.matchBets[i];
        if (matchBet && Object.keys(matchBet).length > 0) {
          headerBets.push(this.$store.state.live.bets[this.idSport][matchBet.idBet]);
        } else {
          headerBets.push({});
        }
      }

      return headerBets;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-bets-container {
  overflow: hidden;
}

.row {
  color: $color-text-primary;
  background-color: $match-color-back;
  border: 0;

  &.row-light {
    background-color: $match-color-back-even;
  }
}

.sport-header-bets {
  color: $color-text-primary;
  font-weight: $font-weight-bold;
  @if $sport-header-gradient == false {
    background-color: $sport-header-color-back;
  } @else {
    background-image: $sport-header-color-back-gradient;
  }

  .sport-header-bet {
    float: left;
    width: 16.66%;
  }

  /deep/ .bet-id:after {
    background-color: $sport-header-bet-top-color-back !important;
  }
}

.match-bets {
  .match-bet {
    float: left;
    width: 16.66%;
  }

  .match-bet:first-child {
    &:after {
      background-color: transparent !important;
    }
  }
}

.locked:after {
  width: 0 !important;
}
</style>
